/*
  FC Products Group — behaviour for the FC Products Group product block.
  Hovering or keyboard-focusing a sibling-product chip swaps the variant-name
  pill to that product's fc.variant_name; leaving restores the active one.
  Loaded by sections/main-product.liquid only when the block is present.
  Developer: Alfie
  Updated:   2026-08-20
*/

if (!customElements.get('fc-products-group')) {
  customElements.define('fc-products-group', class FcProductsGroup extends HTMLElement {
    connectedCallback() {
      this.pill = this.querySelector('[data-fc-group-name]');
      if (!this.pill) return;
      this.activeName = this.pill.textContent.trim();

      this.addEventListener('mouseover', this.onEnter.bind(this));
      this.addEventListener('focusin', this.onEnter.bind(this));
      this.addEventListener('mouseout', this.onLeave.bind(this));
      this.addEventListener('focusout', this.onLeave.bind(this));
    }

    onEnter(event) {
      const chip = event.target.closest('[data-variant-name]');
      if (chip) this.pill.textContent = chip.dataset.variantName;
    }

    onLeave(event) {
      const chip = event.target.closest('[data-variant-name]');
      if (chip) this.pill.textContent = this.activeName;
    }
  });
}
